<template>
  <section id="group">
    <el-row :gutter="24">
      <el-col :span="24">
        <div class="left">
          <template v-for="(group, index) in groupList">
            <div class="group" :key="index" @click="getUserByGroupId(group.id)">
              <div @click.stop="() => {}">
                <el-checkbox
                  size="medium"
                  v-model="group.checked"
                  @change="change(group, 'group')"
                >
                  <img class="tag-ava" :src="'img/group.png'" />{{
                    group.name
                  }}</el-checkbox
                >
              </div>
            </div>
          </template>
          <div>
            <div class="right-empty" v-show="loadingGroup">
              载入中...
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
// import UserList from "./userList.vue";
// import qs from "querystring";
// import url from "./this.url.js";

export default {
  props: ["chosen", "model", "max", "url"],
  data() {
    return {
      groupList: [], // 分組列表
      userList: [], // 人員列表
      tmpChosen: this.chosen, // 臨時選中的值
      loadingGroup: true, // 左側文案相關
      loadingUser: false, // 右側文案相關
      hasClick: false, // 右側文案相關
      activeGroup: 0 // 阻止重複點擊
    };
  },
  components: {
    // UserList // 右侧人員列表
  },
  methods: {
    // 获取分組列表
    getGroupList() {
      this.$common
        .http({
          url: this.url.getGroupList
        })
        .then(res => {
          this.loadingGroup = false;
          this.groupList = res.data.data;
          this.updateChecked("group");
        });
    },
    // 根據分組id獲取人員
    getUserByGroupId(gid) {
      if (this.activeGroup === gid) {
        return false;
      }
      this.hasClick = true;
      this.loadingUser = true;
      this.userList = [];
      this.activeGroup = gid;
      this.$common
        .http({
          url: this.url.getUesrByGroupId,
          data: {
            id: gid,
            page: 1,
            page_size: 99999,
            keyword: ""
          }
        })
        .then(res => {
          this.loadingUser = false;
          this.userList = res.data.data.items;
          this.updateChecked("user");
        });
    },
    // 分組和人員選中或者取消選中
    change(data, type) {
      if (data.checked) {
        if (this.max && Object.keys(this.tmpChosen[type]) + 1 > this.max) {
          this.$common.error("最多只能选择" + this.max + "个选项!");
        } else {
          if (!this.tmpChosen[type]) {
            this.tmpChosen[type] = {};
          } // 如果沒有, 創建一個
          this.tmpChosen[type][data.id] = data;
        }
      } else {
        delete this.tmpChosen[type][data.id];
      }
      this.tmpChosen = this.$common.deep(this.tmpChosen);
    },
    // 更新選擇狀態
    updateChecked(type) {
      const listName = type + "List";
      const list = this[listName];
      for (let index in list) {
        const targ = this.chosen[type];
        list[index].checked = Boolean(targ && targ[list[index].id]);
      }
      this[type + "List"] = this.$common.deep(list);
    }
  },
  watch: {
    chosen: function(val) {
      this.tmpChosen = val;
      this.updateChecked("user");
      this.updateChecked("group");
    },
    tmpChosen: {
      deep: true,
      handler: function(val) {
        this.$emit("updateChosen", val);
      }
    }
  },
  created() {
    this.getGroupList();
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#group {
  .left,
  .right {
    // padding: 0 15px;
    height: 225px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.group {
  cursor: pointer;
  padding: 5px;
  .el-checkbox {
    display: block;
    .el-checkbox__input {
      float: right;
      .el-checkbox__inner {
        top: 5px;
      }
    }
  }
  .name {
    position: relative;
    margin-left: 3px;
    top: -5px;
  }
}
.group.active {
  background: #efefef;
}
</style>
